import type { FC } from "react";
import React from "react";

import { Loader } from "../../../../Loader";
import { createDisplayNameForButtonCircleElement } from "../../utils/getDisplayName";
import { createTestIdForButtonCircleElement } from "../../utils/getTestId";

import type { PickOfUnion } from "../../../../../types/react";
import type { LoaderProps } from "../../../../Loader";
import type { ILoader } from "../../../../Loader/types";

type ButtonCircleLoaderProps = PickOfUnion<
    LoaderProps,
    "label" | "view" | "customColorsStyles"
> &
    Pick<ILoader, "size">;

const name = "Loader";
const displayName = createDisplayNameForButtonCircleElement(name);
const testId = createTestIdForButtonCircleElement(name);

export const ButtonCircleLoader: FC<ButtonCircleLoaderProps> = (props) => {
    return <Loader {...props} data-tsid={testId} />;
};

ButtonCircleLoader.displayName = displayName;

export default ButtonCircleLoader;
